import React, { Component } from 'react'
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import "./textarea.scss";
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));
const InfoButton = asyncRoute(()=> import('../../InfoButton'));

export default class index extends Component {
  render() {
    const { onChange, onBlur, setting, submited, touched, error, value, infoIcon = false, onInfoClick=()=>{} } = this.props;
    const { labelLayout = 'col-sm-4',showOptional = true,addBreakOptional = true, infoStyle } = setting
    return (
      <div className="form-group row custom-textarea ">
        {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required)?<span className='text-danger'>*</span>:(showOptional &&  <>
          {
          !setting.required && addBreakOptional &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        {addBreakOptional && <br />}<span className="small" style={{ color: "#1925238a" }}>Optional</span></>)}
        {
          (setting.required || !addBreakOptional) &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        </label>}
        <div className={setting.displayLayout}>
          <textarea
            id={setting.key}
            className={isEmpty(error) ? "form-control" : "form-control has-error"}
            onChange={onChange}
            onBlur={onBlur}
            rows={setting.rows}
            cols={setting.cols}
            type={setting.type}
            name={setting.key}
            min={setting.min}
            max={setting.max}
            value={value}
            placeholder={setting.placeholder}
          />
          {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
      </div>
    )
  }
}

// -----* Textarea propTypes set *-----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  
   // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
  }),
}